import React from 'react';
import { Form } from 'react-bootstrap';
import Select from 'react-select';

function SelectBox({
  id,
  name,
  options,
  isClearable,
  value,
  placeholder,
  handleChange,
  label,
  classLabel,
  style,
  required
}) {
  return (
    <Form.Group className='mb-2'>
      {label && <Form.Label className={classLabel}>{label}</Form.Label>}
      {required && <span className='text-danger'>*</span>}
      <Select
        id={id}
        name={name}
        isClearable={isClearable}
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        value={value}
        styles={style}
      />
    </Form.Group>
  );
}

export default SelectBox;
